export default class Enum {
  constructor(public key:string, public readonly text:string) {};
}